// utility functions
if(!Util) function Util () {};

Util.addClass = function(el, className) {
  var classList = className.split(' ');
  el.classList.add(classList[0]);
  if (classList.length > 1) Util.addClass(el, classList.slice(1).join(' '));
};

Util.removeClass = function(el, className) {
  var classList = className.split(' ');
  el.classList.remove(classList[0]);
  if (classList.length > 1) Util.removeClass(el, classList.slice(1).join(' '));
};

Util.toggleClass = function(el, className, bool) {
  if(bool) Util.addClass(el, className);
  else Util.removeClass(el, className);
};

Util.setAttributes = function(el, attrs) {
  for(var key in attrs) {
    el.setAttribute(key, attrs[key]);
  }
};

Util.hasClass = function(el, className) {
  return el.classList.contains(className);
};

Util.getChildrenByClassName = function(el, className) {
  var children = el.children,
    childrenByClass = [];
  for (var i = 0; i < children.length; i++) {
    if (Util.hasClass(children[i], className)) childrenByClass.push(children[i]);
  }
  return childrenByClass;
};

Util.getIndexInArray = function(array, el) {
  return Array.prototype.indexOf.call(array, el);
};


// File#: _1_read-more
// Usage: codyhouse.co/license
(function() {
	var ReadMore = function(element) {
	  this.element = element;
	  this.moreContent = this.element.getElementsByClassName('js-read-more__content');
	  this.count = this.element.getAttribute('data-characters') || 200;
	  this.counting = 0;
	  this.btnClasses = this.element.getAttribute('data-btn-class');
	  this.ellipsis = this.element.getAttribute('data-ellipsis') && this.element.getAttribute('data-ellipsis') == 'off' ? false : true;
	  this.btnShowLabel = 'Read more';
	  this.btnHideLabel = 'Read less';
	  this.toggleOff = this.element.getAttribute('data-toggle') && this.element.getAttribute('data-toggle') == 'off' ? false : true;
	  if( this.moreContent.length == 0 ) splitReadMore(this);
	  setBtnLabels(this);
	  initReadMore(this);
	};
  
	function splitReadMore(readMore) { 
	  splitChildren(readMore.element, readMore); // iterate through children and hide content
	};
  
	function splitChildren(parent, readMore) {
	  if(readMore.counting >= readMore.count) {
		Util.addClass(parent, 'js-read-more__content');
		return parent.outerHTML;
	  }
	  var children = parent.childNodes;
	  var content = '';
	  for(var i = 0; i < children.length; i++) {
		if (children[i].nodeType == Node.TEXT_NODE) {
		  content = content + wrapText(children[i], readMore);
		} else {
		  content = content + splitChildren(children[i], readMore);
		}
	  }
	  parent.innerHTML = content;
	  return parent.outerHTML;
	};
  
	function wrapText(element, readMore) {
	  var content = element.textContent;
	  if(content.replace(/\s/g,'').length == 0) return '';// check if content is empty
	  if(readMore.counting >= readMore.count) {
		return '<span class="js-read-more__content">' + content + '</span>';
	  }
	  if(readMore.counting + content.length < readMore.count) {
		readMore.counting = readMore.counting + content.length;
		return content;
	  }
	  var firstContent = content.substr(0, readMore.count - readMore.counting);
	  firstContent = firstContent.substr(0, Math.min(firstContent.length, firstContent.lastIndexOf(" ")));
	  var secondContent = content.substr(firstContent.length, content.length);
	  readMore.counting = readMore.count;
	  return firstContent + '<span class="js-read-more__content">' + secondContent + '</span>';
	};
  
	function setBtnLabels(readMore) { // set custom labels for read More/Less btns
	  var btnLabels = readMore.element.getAttribute('data-btn-labels');
	  if(btnLabels) {
		var labelsArray = btnLabels.split(',');
		readMore.btnShowLabel = labelsArray[0].trim();
		readMore.btnHideLabel = labelsArray[1].trim();
	  }
	};
  
	function initReadMore(readMore) { // add read more/read less buttons to the markup
	  readMore.moreContent = readMore.element.getElementsByClassName('js-read-more__content');
	  if( readMore.moreContent.length == 0 ) {
		Util.addClass(readMore.element, 'read-more--loaded');
		return;
	  }
	  var btnShow = ' <button class="js-read-more__btn '+readMore.btnClasses+'">'+readMore.btnShowLabel+'</button>';
	  var btnHide = ' <button class="js-read-more__btn rh9-hide '+readMore.btnClasses+'">'+readMore.btnHideLabel+'</button>';
	  if(readMore.ellipsis) {
		btnShow = '<span class="js-read-more__ellipsis" aria-hidden="true">...</span>'+ btnShow;
	  }
  
	  readMore.moreContent[readMore.moreContent.length - 1].insertAdjacentHTML('afterend', btnHide);
	  readMore.moreContent[0].insertAdjacentHTML('afterend', btnShow);
	  resetAppearance(readMore);
	  initEvents(readMore);
	};
  
	function resetAppearance(readMore) { // hide part of the content
	  for(var i = 0; i < readMore.moreContent.length; i++) Util.addClass(readMore.moreContent[i], 'rh9-hide');
	  Util.addClass(readMore.element, 'read-more--loaded'); // show entire component
	};
  
	function initEvents(readMore) { // listen to the click on the read more/less btn
	  readMore.btnToggle = readMore.element.getElementsByClassName('js-read-more__btn');
	  readMore.ellipsis = readMore.element.getElementsByClassName('js-read-more__ellipsis');
  
	  readMore.btnToggle[0].addEventListener('click', function(event){
		event.preventDefault();
		updateVisibility(readMore, true);
	  });
	  readMore.btnToggle[1].addEventListener('click', function(event){
		event.preventDefault();
		updateVisibility(readMore, false);
	  });
	};
  
	function updateVisibility(readMore, visibile) {
	  for(var i = 0; i < readMore.moreContent.length; i++) Util.toggleClass(readMore.moreContent[i], 'rh9-hide', !visibile);
	  // reset btns appearance
	  Util.toggleClass(readMore.btnToggle[0], 'rh9-hide', visibile);
	  Util.toggleClass(readMore.btnToggle[1], 'rh9-hide', !visibile);
	  if(readMore.ellipsis.length > 0 ) Util.toggleClass(readMore.ellipsis[0], 'rh9-hide', visibile);
	  if(!readMore.toggleOff) Util.addClass(readMore.btn, 'rh9-hide');
	  // move focus
	  if(visibile) {
		var targetTabIndex = readMore.moreContent[0].getAttribute('tabindex');
		Util.moveFocus(readMore.moreContent[0]);
		resetFocusTarget(readMore.moreContent[0], targetTabIndex);
	  } else {
		Util.moveFocus(readMore.btnToggle[0]);
	  }
	};
  
	function resetFocusTarget(target, tabindex) {
	  if( parseInt(target.getAttribute('tabindex')) < 0) {
			  target.style.outline = 'none';
			  !tabindex && target.removeAttribute('tabindex');
		  }
	};
  
	//initialize the ReadMore objects
	  var readMore = document.getElementsByClassName('js-read-more');
	  if( readMore.length > 0 ) {
		  for( var i = 0; i < readMore.length; i++) {
			  (function(i){new ReadMore(readMore[i]);})(i);
		  }
	  };
  }());


// File#: _1_tabs
// Usage: codyhouse.co/license
(function() {
	var Tab = function(element) {
		this.element = element;
		this.tabList = this.element.getElementsByClassName('js-tabs__controls')[0];
		this.listItems = this.tabList.getElementsByTagName('li');
		this.triggers = this.tabList.getElementsByTagName('a');
		this.panelsList = this.element.getElementsByClassName('js-tabs__panels')[0];
		this.panels = Util.getChildrenByClassName(this.panelsList, 'js-tabs__panel');
		this.hideClass = this.element.getAttribute('data-hide-panel-class') ? this.element.getAttribute('data-hide-panel-class') : 'th8-hide';
		this.customShowClass = this.element.getAttribute('data-show-panel-class') ? this.element.getAttribute('data-show-panel-class') : false;
		this.layout = this.element.getAttribute('data-tabs-layout') ? this.element.getAttribute('data-tabs-layout') : 'horizontal';
		// deep linking options
		this.deepLinkOn = this.element.getAttribute('data-deep-link') == 'on';
		// init tabs
		this.initTab();
	};

	Tab.prototype.initTab = function() {
		//set initial aria attributes
		this.tabList.setAttribute('role', 'tablist');
		Util.addClass(this.element, 'tabs--no-interaction');

		for( var i = 0; i < this.triggers.length; i++) {
			var bool = (i == 0),
				panelId = this.panels[i].getAttribute('id');
			this.listItems[i].setAttribute('role', 'presentation');
			Util.setAttributes(this.triggers[i], {'role': 'tab', 'aria-selected': bool, 'aria-controls': panelId, 'id': 'tab-'+panelId});
			Util.addClass(this.triggers[i], 'js-tabs__trigger'); 
			Util.setAttributes(this.panels[i], {'role': 'tabpanel', 'aria-labelledby': 'tab-'+panelId});
			Util.toggleClass(this.panels[i], this.hideClass, !bool);
			if(bool && this.customShowClass) Util.addClass(this.panels[i], this.customShowClass);

			if(!bool) this.triggers[i].setAttribute('tabindex', '-1'); 
		}

		//listen for Tab events
		this.initTabEvents();

		// check deep linking option
		this.initDeepLink();
	};

	Tab.prototype.initTabEvents = function() {
		var self = this;
		//click on a new tab -> select content
		this.tabList.addEventListener('click', function(event) {
			if( event.target.closest('.js-tabs__trigger') ) self.triggerTab(event.target.closest('.js-tabs__trigger'), event);
		});
		//arrow keys to navigate through tabs 
		this.tabList.addEventListener('keydown', function(event) {
			;
			if( !event.target.closest('.js-tabs__trigger') ) return;
			if( tabNavigateNext(event, self.layout) ) {
				event.preventDefault();
				self.selectNewTab('next');
			} else if( tabNavigatePrev(event, self.layout) ) {
				event.preventDefault();
				self.selectNewTab('prev');
			}
		});
	};

	Tab.prototype.selectNewTab = function(direction) {
		var selectedTab = this.tabList.querySelector('[aria-selected="true"]'),
			index = Util.getIndexInArray(this.triggers, selectedTab);
		index = (direction == 'next') ? index + 1 : index - 1;
		//make sure index is in the correct interval 
		//-> from last element go to first using the right arrow, from first element go to last using the left arrow
		if(index < 0) index = this.listItems.length - 1;
		if(index >= this.listItems.length) index = 0;	
		this.triggerTab(this.triggers[index]);
		this.triggers[index].focus();
	};

	Tab.prototype.triggerTab = function(tabTrigger, event) {
		var self = this;
		event && event.preventDefault();	
		var index = Util.getIndexInArray(this.triggers, tabTrigger);
		//no need to do anything if tab was already selected
		if(this.triggers[index].getAttribute('aria-selected') == 'true') return;

		Util.removeClass(this.element, 'tabs--no-interaction');
		
		for( var i = 0; i < this.triggers.length; i++) {
			var bool = (i == index);
			Util.toggleClass(this.panels[i], this.hideClass, !bool);
			if(this.customShowClass) Util.toggleClass(this.panels[i], this.customShowClass, bool);
			this.triggers[i].setAttribute('aria-selected', bool);
			bool ? this.triggers[i].setAttribute('tabindex', '0') : this.triggers[i].setAttribute('tabindex', '-1');
		}

		// update url if deepLink is on
		if(this.deepLinkOn) {
			history.replaceState(null, '', '#'+tabTrigger.getAttribute('aria-controls'));
		}
	};

	Tab.prototype.initDeepLink = function() {
		if(!this.deepLinkOn) return;
		var hash = window.location.hash.substr(1);
		var self = this;
		if(!hash || hash == '') return;
		for(var i = 0; i < this.panels.length; i++) {
			if(this.panels[i].getAttribute('id') == hash) {
				this.triggerTab(this.triggers[i], false);
				setTimeout(function(){self.panels[i].scrollIntoView(true);});
				break;
			}
		};
	};

	function tabNavigateNext(event, layout) {
		if(layout == 'horizontal' && (event.keyCode && event.keyCode == 39 || event.key && event.key == 'ArrowRight')) {return true;}
		else if(layout == 'vertical' && (event.keyCode && event.keyCode == 40 || event.key && event.key == 'ArrowDown')) {return true;}
		else {return false;}
	};

	function tabNavigatePrev(event, layout) {
		if(layout == 'horizontal' && (event.keyCode && event.keyCode == 37 || event.key && event.key == 'ArrowLeft')) {return true;}
		else if(layout == 'vertical' && (event.keyCode && event.keyCode == 38 || event.key && event.key == 'ArrowUp')) {return true;}
		else {return false;}
	};

	window.Tab = Tab;
	
	//initialize the Tab objects
	var tabs = document.getElementsByClassName('js-tabs');
	if( tabs.length > 0 ) {
		for( var i = 0; i < tabs.length; i++) {
			(function(i){new Tab(tabs[i]);})(i);
		}
	}
}());


(function() {


    function selectTab( tab_parent, tab_id){
        var selected_tab = '#tab-' + tab_id;
		console.log(selected_tab);
        var selected_tabObject = tab_parent.querySelector(selected_tab);
        selected_tabObject.click();
    }

	// function launchSliderTab(currentTab){
	// 	console.log(currentTab);
	// 	var selected_tab = document.getElementById(currentTab);
	// 	console.log(selected_tab)
	// 	var slideshowEl = selected_tab.getElementsByClassName('slideshow')[0];
	// 	console.log(slideshowEl);
		
	// 	new Slideshow({
	// 	element: slideshowEl,
	// 	navigation: false, // show dots navigation
	// 	autoplay : false, // enable/disable autoplay
	// 	autoplayInterval : false, // in milliseconds - default is 5000 (5s)
	// 	autoplayOnHover: false, // do not pause autoplay on hover
	// 	swipe : false // enable/disable swipe
	// 	});

	// }

    function selectOption(tab_parent, tab_value){
        tab_parent.value = tab_value;
    }

    var featured_tabs = document.querySelectorAll('.shopify-section--featured-tabs');

    featured_tabs.forEach(function(featured_tab){
       var tab_selects = featured_tab.querySelectorAll('.popover_tab_options-option');
       var tab_controls = featured_tab.querySelectorAll('.tabs__control');

	   tab_selects.forEach(function(tab_select){
		tab_select.addEventListener('click',function(e){
			var select_target = e.target.getAttribute('value');
			console.log(select_target);

			selectTab(featured_tab, select_target);
		})
	   });
    

       tab_controls.forEach(function(tab_control){
        tab_control.addEventListener('click', function(e){
          var select_target = e.target.getAttribute('aria-controls');
        //   selectOption(tab_select, select_target);
		//   launchSliderTab(select_target);

		 
        });
       });
    });


}());
